import { useTranslation } from 'react-i18next';

import { InfoTooltip, useCurrencyCodeConverter } from '@treezor/design-system';

import { useI18nLocale } from '@/hooks/useI18nLocale';
import { ITransactionByDigitizedCard } from '@/features/cards/store/models/card.model';
import {
  getCardTransactionConfigKey,
  TCardTransactionColumnSetting,
} from '@/features/cards/store/models/card-transactions.model';

export interface IPaymentAmountCellProps {
  transaction: ITransactionByDigitizedCard;
  config?: TCardTransactionColumnSetting;
}

export function PaymentAmountCell({ transaction, config }: IPaymentAmountCellProps) {
  const { t } = useTranslation();
  const { convertCurrencyToCode } = useCurrencyCodeConverter();

  const locale = useI18nLocale();
  const formattedLocale = locale.length > 2 ? `${locale.slice(0, 2)}-${locale.slice(2)}` : locale;

  const hasLocalAmount =
    getCardTransactionConfigKey(config, 'paymentLocalAmount') &&
    !!transaction?.paymentCurrency &&
    transaction.paymentCurrency !== transaction?.walletCurrency;

  return (
    <div className="flex items-center justify-end gap-2">
      <span className="text-secondary">
        {Intl.NumberFormat(formattedLocale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
          Number(transaction.paymentAmount),
        )}
      </span>
      {hasLocalAmount && (
        <InfoTooltip
          tooltipInfo={
            <div className="flex items-center gap-2 whitespace-nowrap">
              <span className="typo-body-regular-small font-light">
                {t('pages.currentProfiles.cards.transactions.table.tooltips.localAmount')}
              </span>
              <span className="typo-body-medium-small">{`${transaction.paymentLocalAmount} (${convertCurrencyToCode(transaction.paymentCurrency) || ''})`}</span>
            </div>
          }
        />
      )}
    </div>
  );
}
